import React, {
  useState,
  useEffect
} from 'react';

import {SiteLinks} from '../../general';

function ThesisFirstSeminarPageInfo() {
  return (<SiteLinks screen="s2_student_seminar_1" />);
}

export {ThesisFirstSeminarPageInfo};